export { GenerarNotaDeCreditoModalEdit, Props } from "./modal";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/notacredito/generarnotasdecredito/index.tsx